<template>
  <Component
    :is="starComponent"
    :key="review"
    :fill="fill"
    :size="size"
  />
</template>

<script setup>
import V2AtomsBaseStarsFiveStar from '~/components/v2/atoms/BaseStars/FiveStar/index.vue'
import V2AtomsBaseStarsFourAndHalfStar from '~/components/v2/atoms/BaseStars/FourAndHalfStar/index.vue'
import V2AtomsBaseStarsFourStar from '~/components/v2/atoms/BaseStars/FourStar/index.vue'
import V2AtomsBaseStarsThreeAndHalfStar from '~/components/v2/atoms/BaseStars/ThreeAndHalfStar/index.vue'
import V2AtomsBaseStarsThreeStar from '~/components/v2/atoms/BaseStars/ThreeStar/index.vue'
import V2AtomsBaseStarsTwoAndHalfStar from '~/components/v2/atoms/BaseStars/TwoAndHalfStar/index.vue'
import V2AtomsBaseStarsTwoStar from '~/components/v2/atoms/BaseStars/TwoStar/index.vue'
import V2AtomsBaseStarsOneAndHalfStar from '~/components/v2/atoms/BaseStars/OneAndHalfStar/index.vue'
import V2AtomsBaseStarsOneStar from '~/components/v2/atoms/BaseStars/OneStar/index.vue'

defineOptions({
  name: 'V2AtomsBaseStars'
})

const props = defineProps({
  review: {
    type: Number,
    required: true,
    validator: value => {
      if (!value) return 1
      const isValidRange = value >= 1 && value <= 5
      const isValidIncrement = value % 0.5 === 0
      return isValidRange && isValidIncrement
    }
  },
  fill: {
    type: String,
    default: () => semanticColorLookup('primary.variant-light')
  },
  size: {
    type: String,
    default: 'base',
    validator: value => ['base', 'large'].includes(value)
  }
})

const starComponent = computed(() => {
  const review = props.review
  switch (review) {
    case 1: return V2AtomsBaseStarsOneStar
    case 1.5: return V2AtomsBaseStarsOneAndHalfStar
    case 2: return V2AtomsBaseStarsTwoStar
    case 2.5: return V2AtomsBaseStarsTwoAndHalfStar
    case 3: return V2AtomsBaseStarsThreeStar
    case 3.5: return V2AtomsBaseStarsThreeAndHalfStar
    case 4: return V2AtomsBaseStarsFourStar
    case 4.5: return V2AtomsBaseStarsFourAndHalfStar
    case 5: return V2AtomsBaseStarsFiveStar
    default: return V2AtomsBaseStarsOneStar
  }
})
</script>
